export enum CommissionType {
  COMMISSION = 'COMMISSION',
  OVER = 'OVER',
  REFERRAL = 'REFERRAL',
}
